import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
    selector: 'page-header',
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss',
    standalone: true,
    imports: [CommonModule, NgOptimizedImage, TranslateModule,RouterModule]
})
export class PageHeaderComponent {
    
    breadcrumbData = input.required<{ label: string; route: string; }[]>()
    exportButtonClick = input<() => void>();
    refreshButtonClick = input<() => void>();
    sendReportBtnClick = input<() => void>();
    fullUserRoleVerticle: any;
    constructor(private router: Router, private ls: LocalStorageService) {   
        this.fullUserRoleVerticle = this.ls.get('fullUserRoleVerticle')
    }
}
